import setFullbanner from './home/1_fullbanner';
import setBrandsCarousel from './home/brands_carousel';

import setCarousel from '../components/carousel';

//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';
import setBannerLinha from './home/home_banner_linha';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();
    
    setFullbanner()
		setBrandsCarousel();
		setBannerLinha();
		setCarousel();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
